import React from "react"
import styled from '@emotion/styled'
import BackgroundImage from 'gatsby-background-image'

const Container = styled.section`
  background: #fff;
`

const ContainerInner = styled.div`
  padding: 5rem 0 4rem;
  max-width: 960px;
  margin: auto;
`

const Title = styled.h5`
  position: relative;
  margin-bottom: 1.25rem;
  color: #91b7cc;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 10px;
  text-transform: uppercase;

  &:before {
    position: absolute;
    left: -70px;
    top: 1ex;
    display: block;
    content: '';
    border-top: 1px solid #91b7cc;
    width: 50px;
    height: 16px;
  }
`

const BackgroundContainer = ({backgroundImage, ...props}) => {
  return (
  backgroundImage
  ? <BackgroundImage
      Tag="section"
      fluid={backgroundImage}
      {...props} />
  : <Container {...props} />
)}

const Section = ({id, backgroundImage, backgroundColor="#fff", title, className, children}) => (
  <BackgroundContainer
    id={id}
    className={className}
    backgroundImage={backgroundImage}
    backgroundColor={backgroundColor}
  >
    <ContainerInner>
      <Title>{title}</Title>
      {children}
    </ContainerInner>
  </BackgroundContainer>
)

export default Section
